import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './SignUp.module.css';
import Logo from 'assets/images/logos/logo-dark-backgrounds.svg';
import AuthForm from 'containers/Auth/AuthForm/AuthForm';
import { checkValidity, updateObject } from 'shared/utility';
import * as actions from 'store/actions';
import { signUpUser } from 'store/thunks';

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controls: {
        firstname: {
          step: 1,
          elementType: 'input',
          elementConfig: {
            type: 'text',
            placeholder: 'First name',
            readOnly: false,
          },
          value: '',
          validation: {
            required: true,
          },
          touched: false,
          valid: false,
        },
        lastname: {
          step: 1,
          elementType: 'input',
          elementConfig: {
            type: 'text',
            placeholder: 'Last name',
            readOnly: false,
          },
          value: '',
          validation: {
            required: true,
          },
          touched: false,
          valid: false,
        },
        email: {
          step: 1,
          elementType: 'input',
          elementConfig: {
            type: 'email',
            placeholder: 'Email',
            autoComplete: 'email',
          },
          value: '',
          validation: {
            required: true,
            isEmail: true,
            validationError: 'Please enter a valid email address',
          },
          valid: false,
          touched: false,
        },
        password: {
          step: 2,
          elementType: 'input',
          elementConfig: {
            type: 'password',
            placeholder: 'Password',
            autoComplete: 'new-password',
            maxLength: 40,
          },
          value: '',
          validation: {
            required: true,
            isPassword: true,
            validationError: '',
          },
          valid: false,
          touched: false,
        },
        passwordConfirmation: {
          step: 2,
          elementType: 'input',
          elementConfig: {
            type: 'password',
            placeholder: 'Password Confirmation',
            maxLength: 40,
          },
          value: '',
          validation: {
            required: true,
            matchesPassword: true,
            validationError: '',
          },
          valid: false,
          touched: false,
        },
      },
      acceptTerms: false,
      reCapthaAuthorized: false,
      step: 1,
      stepOneIsValid: false,
      stepTwoIsValid: false,
    };
  }

  componentDidMount() {
    this.props.onClearAppError();
    // redirect user to verification screen if they started the account creation process, but haven't yet verified their email address
    const codeSentTo = localStorage.getItem('codeSentTo');
    if (codeSentTo === 'Email') {
      this.props.history.push('/verify');
    }
  }

  componentDidUpdate(prevProps) {
    // redirect user to verification screen if they started the account creation process, but haven't yet verified their email address
    if (this.props.accountNeedsVerification && !prevProps.accountNeedsVerification) this.props.history.push('/verify');
  }

  inputChangedHandler = (event, controlName) => {
    const isValid = checkValidity(event.target.value, this.state.controls[controlName].validation, this.state.controls.password.value);
    const updatedControls = updateObject(this.state.controls, {
      [controlName]: updateObject(this.state.controls[controlName], {
        value: event.target.value,
        valid: isValid,
        touched: isValid === true,
      }),
    });
    let stepOneIsValid = true;
    let stepTwoIsValid = true;
    for (const inputIdentifier in updatedControls) {
      if (['email', 'firstname', 'lastname'].includes(inputIdentifier)) {
        stepOneIsValid =
          updatedControls[inputIdentifier].validation.required ||
          (updatedControls[inputIdentifier].value && updatedControls[inputIdentifier].value.length > 1)
            ? updatedControls[inputIdentifier].valid && stepOneIsValid
            : stepOneIsValid;
      } else if (['password', 'passwordConfirmation'].includes(inputIdentifier)) {
        stepTwoIsValid =
          updatedControls[inputIdentifier].validation.required ||
          (updatedControls[inputIdentifier].value && updatedControls[inputIdentifier].value.length > 1)
            ? updatedControls[inputIdentifier].valid && stepTwoIsValid
            : stepTwoIsValid;
      }
    }
    this.setState({ controls: updatedControls, stepOneIsValid, stepTwoIsValid });
  };

  focusedOutHandler = (event, controlName) => {
    const updatedControls = updateObject(this.state.controls, {
      [controlName]: updateObject(this.state.controls[controlName], {
        touched: true,
      }),
    });
    this.setState({ controls: updatedControls });
  };

  toggleTermsCheck = () => {
    this.setState({ acceptTerms: !this.state.acceptTerms });
  };

  submitHandler = (event) => {
    event.preventDefault();
    if (this.state.step === 1) {
      const updatedControls = updateObject(this.state.controls, {
        password: updateObject(this.state.controls.password, {
          value: '',
          touched: false,
        }),
        passwordConfirmation: updateObject(this.state.controls.passwordConfirmation, {
          value: '',
          touched: false,
        }),
      });
      this.setState({ step: 2, controls: updatedControls });
    } else {
      this.props.onSignUp(
        this.state.controls.email.value,
        this.state.controls.password.value,
        this.state.controls.firstname.value,
        this.state.controls.lastname.value,
      );
    }
  };

  onReCapthaChange = (value) => {
    if (value !== null) {
      this.setState({ reCapthaAuthorized: true });
    } else {
      this.setState({ reCapthaAuthorized: false });
    }
  };

  render = () => {
    return (
      <div className={classes.SignUpOuterContainer}>
        <div className={classes.SignUpInnerContainer}>
          <div className={classes.AuthLogo}>
            <img src={Logo} alt="riza" />
          </div>
          {this.state.step === 1 ? <p>Welcome! Create a new Riza account here.</p> : <h2 className={classes.CreatePasswordTitle}>Create Password</h2>}
          <AuthForm
            onReCapthaChange={this.onReCapthaChange}
            toggleTermsCheck={this.toggleTermsCheck}
            acceptTerms={this.state.acceptTerms}
            step={this.state.step}
            error={this.props.error}
            isAuthenticated={this.props.isAuthenticated}
            controls={this.state.controls}
            disabled={
              this.state.step === 1
                ? !this.state.stepOneIsValid || !this.state.reCapthaAuthorized || !this.state.acceptTerms
                : !this.state.stepTwoIsValid || !this.state.stepOneIsValid
            }
            submit={this.submitHandler}
            changed={this.inputChangedHandler}
            focusedOut={this.focusedOutHandler}
            formType="SignUp"
            buttonLabel={this.state.step === 1 ? 'Continue' : 'Create Account'}
          />
          {this.state.step === 2 ? (
            <p onClick={() => this.setState({ step: 1, reCapthaAuthorized: false, acceptTerms: false })} className={classes.Back}>
              Back
            </p>
          ) : null}
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    error: state.auth.signUpError,
    isAuthenticated: state.auth.isAuthenticated !== false,
    accountNeedsVerification: state.auth.CodeSentTo === 'Email',
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSignUp: (Email, Password, FirstName, LastName) => dispatch(signUpUser({ Email, Pass: Password, FirstName, LastName })),
    onClearAppError: () => dispatch(actions.clearAppError()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
